import { Directive, HostBinding, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfElementClass]'
})
export class ElementClassDirective {
  control: any;

  constructor(private viewContainerRef: ViewContainerRef) {
    this.getControl();
  }

  @HostBinding('class')
  get class(): string {
    let c = this.control.model ? this.control.model.class : '';
    c = c ? c : '';
    c = `form-group ` + c + (this.control.isDesign ? ' design' : '');

    c = c + ` col-sm`;
    if (this.control.model.columnLength) {
      c = c + `-` + this.control.model.columnLength;
    }
    return c;
  }

  private getControl() {
    const view = this.viewContainerRef[`_view`];
    if (view) {
      const c = this.viewContainerRef[`_view`][`context`];
      this.control = c;
    }
  }
}
